export const LoginMethodValues = ['oauth', 'emailpwd', 'other'] as const
export type LoginMethodType = (typeof LoginMethodValues)[number]

export type LoginMethodPropPayloadLegacy = {[key in LoginMethodType]?: boolean}
export type LoginMethodPropPayloadNew = {method: LoginMethodType}
export type LoginMethodPropPayload = LoginMethodPropPayloadNew | LoginMethodPropPayloadLegacy
